"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var BaseController_1 = require("../../../../../shared/controllers/BaseController");
var webAApi_1 = require("../../../../api/webAApi");
var UIUtils_1 = require("../../../../../shared/modules/UIUtils");
var moment = require("moment");
var EventBindingsListCtl = /** @class */ (function (_super) {
    __extends(EventBindingsListCtl, _super);
    function EventBindingsListCtl(errDialog) {
        var _this = _super.call(this, true) || this;
        _this.dk_key = UIUtils_1.UIUtils.IProp2Str(function (o) { o.key; });
        _this.dk_brand_id = UIUtils_1.UIUtils.IProp2Str(function (o) { o.brand_id; });
        _this.dk_brand_title = UIUtils_1.UIUtils.IProp2Str(function (o) { o.brand_title; });
        //public readonly dk_app_currency_id = UIUtils.IProp2Str((o: IEventBindingsListItem) => { o.app_currency_id });
        //public readonly dk_app_currency_title = UIUtils.IProp2Str((o: IEventBindingsListItem) => { o.app_currency_title });
        _this.dk_bonus_count_inside = UIUtils_1.UIUtils.IProp2Str(function (o) { o.bonus_count_inside; });
        _this.dk_event_type_code = UIUtils_1.UIUtils.IProp2Str(function (o) { o.event_type_code; });
        _this.dk_event_type_title = UIUtils_1.UIUtils.IProp2Str(function (o) { o.event_type_title; });
        _this.dk_is_player_level = UIUtils_1.UIUtils.IProp2Str(function (o) { o.is_player_level; });
        _this.dk_player_level_id = UIUtils_1.UIUtils.IProp2Str(function (o) { o.player_level_id; });
        _this.dk_player_level_title = UIUtils_1.UIUtils.IProp2Str(function (o) { o.player_level_title; });
        _this.dk_is_locked = UIUtils_1.UIUtils.IProp2Str(function (o) { o.is_locked; });
        _this.dk_title = UIUtils_1.UIUtils.IProp2Str(function (o) { o.title; });
        //public readonly dk_is_bonus_validator = UIUtils.IProp2Str((o: IEventBindingsListItem) => { o.is_bonus_validator });
        //public readonly dk_bonus_validator_id = UIUtils.IProp2Str((o: IEventBindingsListItem) => { o.bonus_validator_id });
        //public readonly dk_bonus_validator_title = UIUtils.IProp2Str((o: IEventBindingsListItem) => { o.bonus_validator_title });
        _this.dk_date_added = UIUtils_1.UIUtils.IProp2Str(function (o) { o.date_added; });
        _this.dk_date_changed = UIUtils_1.UIUtils.IProp2Str(function (o) { o.date_changed; });
        _this.dk_is_can_config = UIUtils_1.UIUtils.IProp2Str(function (o) { o.is_can_config; });
        _this.dk_is_need_amount = UIUtils_1.UIUtils.IProp2Str(function (o) { o.is_need_amount; });
        _this.dk_is_show_bonus_description = UIUtils_1.UIUtils.IProp2Str(function (o) { o.is_show_bonus_description; });
        _this.dk_order_number = UIUtils_1.UIUtils.IProp2Str(function (o) { o.order_number; });
        _this.dk_description = UIUtils_1.UIUtils.IProp2Str(function (o) { o.description; });
        _this._errDialog = errDialog;
        return _this;
    }
    EventBindingsListCtl.prototype.ResetData = function () {
        this.DATA = {
            data: [],
            //currency_filter: [],
            level_filter: [],
            //validator_filter: [],
            event_filter: [],
            total: 0
        };
    };
    EventBindingsListCtl.prototype.getById = function (id) {
        for (var i = 0; i < this.DATA.data.length; i++) {
            if (this.DATA.data[i].key === id) {
                return this.DATA.data[i];
            }
        }
        throw "bonus binding with id [" + id + "] not found !";
    };
    //public getCurrencyFilter(): IBindingFilterInfo[] {
    //    return this.DATA.currency_filter;
    //}
    EventBindingsListCtl.prototype.getLevelFilter = function () {
        return this.DATA.level_filter;
    };
    //public getValidatorFilter(): IBindingFilterInfo[] {
    //    return this.DATA.validator_filter;
    // }
    EventBindingsListCtl.prototype.getEventFilter = function () {
        return this.DATA.event_filter;
    };
    EventBindingsListCtl.prototype.LoadData = function (AllBrands, BrandIdList, onDone) {
        var _this = this;
        webAApi_1.ListBonusEventsBindingsByBrandIdGet.exec({
            all_brands: AllBrands,
            brand_id_list: BrandIdList
        }, function (resp) {
            _this.DATA.data = [];
            _this.DATA.total = resp.total_count;
            //
            //this.DATA.currency_filter = [];
            //let currency_filter_map = new Map<string, string>();
            //
            _this.DATA.level_filter = [];
            var level_filter_map = new Map();
            //
            //this.DATA.validator_filter = [];
            //let validator_filter_map = new Map<string, string>();                
            //
            _this.DATA.event_filter = [];
            var event_filter_map = new Map();
            //
            for (var i = 0; i < resp.list.length; i++) {
                //if (!currency_filter_map.get(resp.list[i].app_currency_title)) {
                //    this.DATA.currency_filter.push({ text: resp.list[i].app_currency_title, value: resp.list[i].app_currency_title });
                //     currency_filter_map.set(resp.list[i].app_currency_title, resp.list[i].app_currency_title);
                // }
                if (!event_filter_map.get(resp.list[i].event_type_title)) {
                    _this.DATA.event_filter.push({ text: resp.list[i].event_type_title, value: resp.list[i].event_type_title });
                    event_filter_map.set(resp.list[i].event_type_title, resp.list[i].event_type_title);
                }
                var lvl_key = resp.list[i].player_level_title;
                if (!resp.list[i].is_player_level) {
                    lvl_key = "[ВСЕ]";
                }
                if (!level_filter_map.get(lvl_key)) {
                    var lvl_title = resp.list[i].player_level_title;
                    if (!resp.list[i].is_player_level) {
                        lvl_title = "[ВСЕ]";
                    }
                    _this.DATA.level_filter.push({ text: lvl_title, value: lvl_key });
                    level_filter_map.set(lvl_key, lvl_title);
                }
                //let validator_key = resp.list[i].bonus_validator_title;
                //if(!resp.list[i].is_bonus_validator) {
                //    validator_key = "[НЕТ]";
                // }
                /*if (!validator_filter_map.get(validator_key)) {
                    let validator_title = resp.list[i].bonus_validator_title;
                    if(!resp.list[i].is_bonus_validator) {
                        validator_title = "[НЕТ]"
                    }
                    this.DATA.validator_filter.push({ text: validator_title, value: validator_key });
                    validator_filter_map.set(validator_key, validator_title);
                }*/
                _this.DATA.data.push({
                    key: resp.list[i].key_uid,
                    brand_id: resp.list[i].brand_id,
                    brand_title: resp.list[i].brand_title,
                    //app_currency_id: resp.list[i].app_currency_id,
                    //app_currency_title: resp.list[i].app_currency_title,
                    // brand_bonus_template_id: resp.list[i].brand_bonus_template_id,
                    date_added: moment(resp.list[i].date_added_uts_ms).utc(false),
                    date_changed: moment(resp.list[i].date_changed_uts_ms).utc(false),
                    // brand_bonus_template_title: resp.list[i].brand_bonus_template_title,
                    title: resp.list[i].title,
                    event_type_code: resp.list[i].event_type_code,
                    event_type_title: resp.list[i].event_type_title,
                    is_locked: resp.list[i].is_locked,
                    is_player_level: resp.list[i].is_player_level,
                    player_level_id: resp.list[i].player_level_id,
                    //player_level_title: resp.list[i].player_level_title,
                    player_level_title: lvl_key,
                    is_can_config: resp.list[i].is_can_config,
                    is_need_amount: resp.list[i].is_need_amount,
                    bonus_count_inside: resp.list[i].bonus_count_inside,
                    is_show_bonus_description: resp.list[i].is_show_bonus_description,
                    order_number: resp.list[i].order_number,
                    description: resp.list[i].description
                    // is_bonus_validator: resp.list[i].is_bonus_validator,
                    //bonus_validator_id: resp.list[i].bonus_validator_id,
                    //bonus_validator_title: validator_key//resp.list[i].bonus_validator_title
                });
            }
            _this.Update();
            if (onDone) {
                onDone();
            }
        }, function (err) {
            _this._errDialog.ShowApiError(err);
        });
    };
    EventBindingsListCtl.prototype.AddData = function (data, onDone) {
        var _this = this;
        webAApi_1.DoAddBonusEventBinding.exec({
            data: {
                //app_currency_id: data.app_currency_id,
                //bonus_template_id: data.bonus_template_id,
                title: data.title,
                brand_id: data.brand_id,
                event_type_code: data.event_type_code,
                is_locked: data.is_locked,
                is_player_level: data.is_player_level,
                player_level_id: data.player_level_id,
                is_show_bonus_description: data.is_show_bonus_description,
                order_number: data.order_number,
                description: data.description
                // is_bonus_validator: data.is_bonus_validator,
                // bonus_validator_id: data.bonus_validator_id
            }
        }, function (resp) {
            var lvl_key = resp.player_level_title;
            if (!data.is_player_level) {
                lvl_key = "[ВСЕ]";
            }
            // let validator_key = resp.bonus_validator_title;
            // if(!data.is_bonus_validator) {
            //     validator_key = "[НЕТ]";
            // }
            _this.DATA.data.push({
                key: resp.key_uid,
                date_changed: moment(resp.date_changed_uts_ms).utc(false),
                date_added: moment(resp.date_added_uts_ms).utc(false),
                //app_currency_id: data.app_currency_id,
                //app_currency_title: resp.app_currency_title,
                brand_title: resp.brand_title,
                brand_id: data.brand_id,
                //brand_bonus_template_id: data.bonus_template_id,
                //brand_bonus_template_title: resp.bonus_template_title,
                title: data.title,
                event_type_code: data.event_type_code,
                event_type_title: resp.event_type_title,
                is_locked: data.is_locked,
                is_player_level: data.is_player_level,
                player_level_id: data.player_level_id,
                player_level_title: lvl_key,
                is_can_config: resp.is_can_config,
                is_need_amount: resp.is_need_amount,
                bonus_count_inside: 0,
                is_show_bonus_description: data.is_show_bonus_description,
                order_number: data.order_number,
                description: data.description
                // is_bonus_validator: data.is_bonus_validator,
                // bonus_validator_id: data.bonus_validator_id,
                //  bonus_validator_title: validator_key//resp.bonus_validator_title
            });
            _this.DATA.total++;
            _this.Update();
            if (onDone) {
                onDone();
            }
        }, function (err) {
            _this._errDialog.ShowApiError(err);
        });
    };
    EventBindingsListCtl.prototype.EditData = function (data, onDone) {
        var _this = this;
        var _tmp = this.getById(data.key);
        if (_tmp) {
            webAApi_1.DoEditBonusEventBinding.exec({
                data: {
                    bonus_event_binding_id: data.key,
                    //app_currency_id: data.app_currency_id,
                    //bonus_template_id: data.bonus_template_id,
                    //event_type_code: data.event_type_code,
                    title: data.title,
                    is_locked: data.is_locked,
                    is_player_level: data.is_player_level,
                    player_level_id: data.player_level_id,
                    is_show_bonus_description: data.is_show_bonus_description,
                    order_number: data.order_number,
                    description: data.description
                    // is_bonus_validator: data.is_bonus_validator,
                    // bonus_validator_id: data.bonus_validator_id
                }
            }, function (resp) {
                //_tmp.brand_bonus_template_id = data.bonus_template_id,
                //_tmp.brand_bonus_template_title = resp.bonus_template_title;
                //_tmp.app_currency_id = data.app_currency_id;
                //_tmp.app_currency_title = resp.app_currency_title;
                //_tmp.event_type_code = data.event_type_code;
                //_tmp.event_type_title = resp.event_type_title;
                _tmp.is_player_level = data.is_player_level;
                _tmp.player_level_id = data.player_level_id;
                _tmp.player_level_title = resp.player_level_title;
                _tmp.is_locked = data.is_locked;
                _tmp.title = data.title;
                _tmp.date_changed = moment(resp.date_changed_uts_ms).utc(false);
                _tmp.is_show_bonus_description = data.is_show_bonus_description;
                _tmp.order_number = data.order_number;
                _tmp.description = data.description;
                var lvl_key = resp.player_level_title;
                if (!data.is_player_level) {
                    lvl_key = "[ВСЕ]";
                }
                //let validator_key = resp.bonus_validator_title;
                // if(!data.is_bonus_validator) {
                //     validator_key = "[НЕТ]";
                // }
                _tmp.player_level_title = lvl_key;
                //  _tmp.bonus_validator_title = validator_key;
                _this.Update();
                if (onDone) {
                    onDone();
                }
            }, function (err) {
                _this._errDialog.ShowApiError(err);
            });
        }
    };
    EventBindingsListCtl.prototype.RemoveItem = function (key) {
        var i_idx = -1;
        for (var i = 0; i < this.DATA.data.length; i++) {
            if (this.DATA.data[i].key === key) {
                i_idx = i;
            }
        }
        var rest = this.DATA.data.slice(i_idx + 1);
        this.DATA.data.length = i_idx;
        return this.DATA.data.push.apply(this.DATA.data, rest);
    };
    EventBindingsListCtl.prototype.DeleteData = function (key, onDone) {
        var _this = this;
        var _tmp = this.getById(key);
        if (_tmp) {
            webAApi_1.DoDeleteBonusEventBinding.exec({
                data: {
                    bonus_event_binding_id: key
                }
            }, function (resp) {
                _this.RemoveItem(_tmp.key);
                _this.Update();
                if (onDone) {
                    onDone();
                }
            }, function (err) {
                _this._errDialog.ShowApiError(err);
            });
        }
    };
    EventBindingsListCtl.prototype.SetIsLocked = function (key, IsLocked, onDone) {
        var _this = this;
        var _tmp = this.getById(key);
        if (_tmp) {
            webAApi_1.DoSetBonusEventBindingIsLocked.exec({
                data: {
                    bonus_event_binding_id: key,
                    is_locked: IsLocked
                }
            }, function (resp) {
                _tmp.is_locked = IsLocked;
                _tmp.date_changed = moment(resp.date_changed_uts_ms).utc(false);
                _this.Update();
                if (onDone) {
                    onDone();
                }
            }, function (err) {
                _this._errDialog.ShowApiError(err);
            });
        }
    };
    EventBindingsListCtl.prototype.doSetOrderNumber = function (key, OrderNumber, onDone) {
        var _this = this;
        var _tmp = this.getById(key);
        if (_tmp) {
            webAApi_1.DoSetBonusEventBindingPriority.exec({
                data: {
                    event_binding_id: key,
                    order_number: OrderNumber
                }
            }, function (resp) {
                _tmp.order_number = OrderNumber;
                _tmp.date_changed = moment(resp.date_changed_uts_ms).utc(false);
                _this.Update();
                if (onDone) {
                    onDone();
                }
            }, function (err) {
                _this._errDialog.ShowApiError(err);
            });
        }
    };
    return EventBindingsListCtl;
}(BaseController_1.BaseController));
exports.EventBindingsListCtl = EventBindingsListCtl;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/gift_events_bindings/ctl/EventBindingsListCtl.ts
// module id = 883
// module chunks = 0